

export function initObjectFit() {
    /* object fit polyfill for ie */
    if ('objectFit' in document.documentElement.style === false) {
        $('img').each(function () {
            var image = $(this);
            if (image.css('font-family') == '"object-fit: cover;"' && !image.hasClass('objectfitted')) {
                image.css('background', 'url("' + image.attr('src') + '") no-repeat 50%/cover');
                image.attr('src', 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'' + image.width() + '\' height=\'' + image.height() + '\'%3E%3C/svg%3E');
                // Reset srcset property, cause it is interfering with the fallback background image
                image.attr('srcset', '');
                image.addClass('objectfitted');
            }
        });
    }
}

$(window).on("load", function(){
    // Handler when all assets (including images) are loaded
    initObjectFit();
  });